var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Icon / Nav / Reports"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { fill: "#FFF", fillRule: "nonzero", transform: "rotate(-90 4 13)", x: "1", y: "12", width: "6", height: "2", rx: "1" }),
      React.createElement("rect", { fill: "#FFF", fillRule: "nonzero", transform: "rotate(-90 9 11)", x: "4", y: "10", width: "10", height: "2", rx: "1" }),
      React.createElement("rect", { fill: "#FFF", fillRule: "nonzero", transform: "rotate(-90 14 9)", x: "7", y: "8", width: "14", height: "2", rx: "1" })
    )
  );
});